import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import errorStyles from '../../assets/css/error.module.css';
import { WithChildren } from '../../types/utility';
import error500 from '../../assets/images/Error500.png';
import { useTranslation } from 'react-i18next';
import { JSX } from 'react';
import { INTERNAL_ERROR_BOUNDARY_PREFIX } from '../../utils/translationPagePrefix';

type AppErrorBoundaryProps = WithChildren<{
	Fallback?: (props: FallbackProps) => JSX.Element;
}>;

export const TechErrorBoundary = ({ children }: AppErrorBoundaryProps) => {
	return (
		<ErrorBoundary
			FallbackComponent={() => {
				return <InternalErrorFallbackComponent />;
			}}
			onError={(error, componentStack) => {
				// errors that crash application unexpectedly.
				// should be logged carefully and thoroughly using sentry.
				// they should not be happening and are considered bugs.
			}}
		>
			{children}
		</ErrorBoundary>
	);
};

interface InternalErrorProps {
	reference?: string;
}

export const InternalErrorFallbackComponent = (props: InternalErrorProps) => {
	const { t } = useTranslation();

	return (
		<div className={errorStyles['error-container']}>
			<div className={errorStyles['error-content']}>
				<div className={errorStyles['error-icon']}>
					<img src={error500} alt="mantis" style={{ height: '100%', width: '100%' }} />
				</div>
				<div className={errorStyles['error-title']} aria-label="error=title">
					{t(`${INTERNAL_ERROR_BOUNDARY_PREFIX}.tecnical-error`)}
				</div>
				<div className={errorStyles['error-text-container']}>
					<p className={errorStyles['error-text']} aria-label="error-text">
						{t(`${INTERNAL_ERROR_BOUNDARY_PREFIX}.banking-app-crashed`)}
					</p>
					{props.reference && (
						<p className={errorStyles['error-text']} aria-label="error-message">
							{t('error-boundary.reference', { reference: props.reference })}
						</p>
					)}
					<p className={errorStyles['error-text']} aria-label="error-text">
						{t(`${INTERNAL_ERROR_BOUNDARY_PREFIX}.click-reopen`)}
					</p>
				</div>
			</div>
		</div>
	);
};
